import React from 'react';
import EditIcon from '../../assets/images/svg/editLearning.svg';

const truncateStyle = {
  whiteSpace: 'nowrap',
  overflow: 'hidden',
  textOverflow: 'ellipsis',
  padding: '4px 2px'
};

// Helper function to format category names
const formatCategoryName = (category) => {
  if (!category) return '';
  return category
    .split('_')
    .map(word => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
    .join(' ');
};

export const tableColumns = [
  {
    name: 'Report ID',
    selector: row => row.report_id,
    sortable: true,
    center: true,
    width: '180px',
    style: truncateStyle,
  },
  {
    name: 'Name',
    selector: row => row.user_name,
    sortable: true,
    center: true,
    width: '180px',
    cell: row => (
      <div style={{ 
        ...truncateStyle,
        color: '#5C61F2', 
        fontWeight: 'bold',
        width: '100%',
        textAlign: 'center'
      }}>
        {row.user_name}
      </div>
    ),
  },
  {
    name: 'Issue Category',
    selector: row => formatCategoryName(row.issue_category),
    sortable: true,
    center: true,
    width: '180px',
    style: truncateStyle,
  },
  {
    name: 'Urgency Level',
    selector: row => row.urgency_level,
    sortable: true,
    center: true,
    width: '180px',
    style: truncateStyle,
  },
  {
    name: 'Status',
    selector: row => row.status_component,
    sortable: true,
    center: true,
    width: '180px',
    id: 'status',
    style: truncateStyle,
  },
  {
    name: 'Action',
    selector: row => row.action,
    sortable: false,
    center: true,
    width: '180px',
    id: 'action',
    style: truncateStyle,
  }
];